<input type="text" (input)="onSearchChange($event)" />
<i class="fa fa-search"></i>